export const OrderStatusMap = {
    DO_OBSLUGI: "DO OBSŁUGI",
    WYSŁANE: "WYSŁANE",
    W_TRAKCIE: "W TRAKCIE",
    PRZYJĘTE: "PRZYJĘTE",
    ZAKONCZONY: "ZAKOŃCZONY",
    ANULOWANE: "ANULOWANE"
};